import require, { has } from 'require';
let _fetch = null;
export default function getFetchFunction() {
  if (_fetch !== null) {
    return _fetch();
  }
  if (has('fetch')) {
    // use `fetch` module by default, this is commonly provided by ember-fetch
    let fetchFn = require('fetch').default;
    _fetch = () => fetchFn;
  } else if (typeof fetch === 'function') {
    // fallback to using global fetch
    _fetch = () => fetch;
  } else {
    throw new Error('cannot find the `fetch` module or the `fetch` global. Did you mean to install the `ember-fetch` addon?');
  }
  return _fetch();
}